import { flatten } from 'flat';
import { useEffect } from 'react';
import { useFormikContext } from 'formik';

// Adapted code from  https://dev.to/diegocasmo/scroll-to-input-on-formik-failed-submission-1c3c

export const ScrollToFieldError = () => {
    const { submitCount, isValid, errors } = useFormikContext();

    useEffect(() => {
        // Only after someone pressed something. A mask that opens with errors
        // in it — a credit note validates on mount — would otherwise jump past
        // its own head to the first red field before it has even been read
        // (#2208).
        if (0 === submitCount) return;

        if (isValid) return;

        const fieldErrorNames = Object.keys(flatten(errors));
        if (fieldErrorNames.length <= 0) return;

        const element = document.querySelector(
            `input[name='${fieldErrorNames[0]}'], textarea[name='${fieldErrorNames[0]}']`
        );
        if (!element) return;

        // Scroll to first known error into view
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, [submitCount]); // eslint-disable-line react-hooks/exhaustive-deps

    return null;
};
